var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/lib/Table.tsx
import { default as MuiTable } from "@mui/material/Table";
import { jsx } from "react/jsx-runtime";
var Table = (_a) => {
  var _b = _a, { className, striped } = _b, props = __objRest(_b, ["className", "striped"]);
  return /* @__PURE__ */ jsx(MuiTable, __spreadValues({ className: `${striped ? "striped " : ""}${className || ""}` }, props));
};

// src/lib/TableBody.tsx
import { default as MuiTableBody } from "@mui/material/TableBody";
import { jsx as jsx2 } from "react/jsx-runtime";
var TableBody = (props) => {
  return /* @__PURE__ */ jsx2(MuiTableBody, __spreadValues({}, props));
};

// src/lib/TableCell.tsx
import {
  default as MuiTableCell
} from "@mui/material/TableCell";
import { visuallyHidden } from "@availity/mui-utils";
import { Fragment, jsx as jsx3, jsxs } from "react/jsx-runtime";
var TableCell = (_a) => {
  var _b = _a, { disableEmptyPlaceholder = false, children } = _b, props = __objRest(_b, ["disableEmptyPlaceholder", "children"]);
  const isPlaceholderActive = !disableEmptyPlaceholder && !children;
  const placeholder = /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx3("div", { "aria-hidden": true, children: "\u2014" }),
    /* @__PURE__ */ jsx3("div", { style: visuallyHidden, children: "No Data" })
  ] });
  return /* @__PURE__ */ jsx3(MuiTableCell, __spreadProps(__spreadValues({}, props), { children: isPlaceholderActive ? placeholder : children }));
};

// src/lib/TableContainer.tsx
import {
  default as MuiTableContainer
} from "@mui/material/TableContainer";
import { jsx as jsx4 } from "react/jsx-runtime";
var TableContainer = (props) => {
  return /* @__PURE__ */ jsx4(MuiTableContainer, __spreadValues({}, props));
};

// src/lib/TableFooter.tsx
import { default as MuiTableFooter } from "@mui/material/TableFooter";
import { jsx as jsx5 } from "react/jsx-runtime";
var TableFooter = (props) => {
  return /* @__PURE__ */ jsx5(MuiTableFooter, __spreadValues({}, props));
};

// src/lib/TableHead.tsx
import { default as MuiTableHead } from "@mui/material/TableHead";
import { jsx as jsx6 } from "react/jsx-runtime";
var TableHead = (props) => {
  return /* @__PURE__ */ jsx6(MuiTableHead, __spreadValues({}, props));
};

// src/lib/TablePagination.tsx
import { forwardRef, useState } from "react";
import {
  default as MuiTablePagination
} from "@mui/material/TablePagination";
import { Pagination } from "@availity/mui-pagination";
import { SelectAccessibilityOverrides } from "@availity/mui-form-utils";
import { TriangleExpandIcon } from "@availity/mui-icon";
import { Fragment as Fragment2, jsx as jsx7, jsxs as jsxs2 } from "react/jsx-runtime";
var IconComponent = (args) => /* @__PURE__ */ jsx7(TriangleExpandIcon, __spreadValues({ fontSize: "xxsmall", sx: { marginRight: "4px" } }, args));
var TablePagination = forwardRef((props, ref) => {
  const _a = props, { Actions, paginationProps } = _a, rest = __objRest(_a, ["Actions", "paginationProps"]);
  const [openDetected, setOpenDetected] = useState(false);
  const ActionsPagination = (props2) => {
    const _a2 = props2, { count, page, rowsPerPage, onPageChange, nextIconButtonProps, backIconButtonProps, slotProps } = _a2, rest2 = __objRest(_a2, ["count", "page", "rowsPerPage", "onPageChange", "nextIconButtonProps", "backIconButtonProps", "slotProps"]);
    return /* @__PURE__ */ jsxs2(Fragment2, { children: [
      typeof count === "number" && count / rowsPerPage > 1 ? /* @__PURE__ */ jsx7(
        Pagination,
        __spreadProps(__spreadValues(__spreadValues({}, rest2), paginationProps), {
          count: Math.ceil(Math.abs(count / rowsPerPage)),
          page: page + 1,
          onChange: (event, newPage) => {
            onPageChange(event, newPage - 1);
          }
        })
      ) : null,
      Actions || null
    ] });
  };
  return /* @__PURE__ */ jsx7(
    MuiTablePagination,
    __spreadProps(__spreadValues({
      ActionsComponent: ActionsPagination
    }, rest), {
      slotProps: {
        select: __spreadValues({ IconComponent }, SelectAccessibilityOverrides(openDetected, setOpenDetected))
      },
      ref
    })
  );
});

// src/lib/TableRow.tsx
import { default as MuiTableRow } from "@mui/material/TableRow";
import { jsx as jsx8 } from "react/jsx-runtime";
var TableRow = (props) => {
  return /* @__PURE__ */ jsx8(MuiTableRow, __spreadValues({}, props));
};

// src/lib/TableSortLabel.tsx
import {
  default as MuiTableSortLabel
} from "@mui/material/TableSortLabel";
import Box from "@mui/material/Box";
import { visuallyHidden as visuallyHidden2 } from "@availity/mui-utils";
import { SortDownIcon, SortIcon } from "@availity/mui-icon";
import { Fragment as Fragment3, jsx as jsx9, jsxs as jsxs3 } from "react/jsx-runtime";
var TableSortLabel = (props) => {
  const IconComponent2 = props.active ? SortDownIcon : SortIcon;
  const SortedDescription = props.active ? /* @__PURE__ */ jsx9(Box, { component: "span", sx: visuallyHidden2, children: props.direction === "desc" ? "sorted descending" : "sorted ascending" }) : null;
  return /* @__PURE__ */ jsx9(
    MuiTableSortLabel,
    __spreadProps(__spreadValues({}, props), {
      IconComponent: IconComponent2,
      children: /* @__PURE__ */ jsxs3(Fragment3, { children: [
        props.children,
        " ",
        SortedDescription
      ] })
    })
  );
};
export {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel
};
